import InfoIcon from 'components/elements/icons/InfoIcon'
import ErrorText from 'components/elements/texts/ErrorText'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'
import { Property } from 'csstype'
import styled from 'styled-components'

/**
 * エラーメッセージ
 */
const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  const messages = Array.isArray(props.message)
    ? props.message.join('\n')
    : props.message
  return (
    <ErrorArea
      transparent={props.transparent}
      marginNone={props.marginNone}
      justifyContent={props.justifyContent}
    >
      <InfoIcon
        width="20px"
        color={CLIENT_SETTINGS.colors.textForMainBackground}
      />
      <ErrorText>{messages}</ErrorText>
    </ErrorArea>
  )
}

type ErrorMessageProps = {
  message: string | string[]
  transparent?: boolean
  marginNone?: boolean
  justifyContent?: Property.JustifyContent
}

const ErrorArea = styled.div<{
  transparent?: boolean
  marginNone?: boolean
  justifyContent?: Property.JustifyContent
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props): Property.JustifyContent =>
    props.justifyContent ? props.justifyContent : 'center'};
  margin: ${(props): string => (props.marginNone ? '' : '24px 0 0')};
  padding: 8px 16px;
  background: ${(props): string =>
    props.transparent
      ? `${CLIENT_SETTINGS.colors.error}eb`
      : 'var(--color-error)'};
  && * {
    margin: 0 4px;
  }
`

export default React.memo(ErrorMessage)
